export default __webpack_public_path__ + "static/media/button-google-play.2bbac370.svg";